import { createContext, useContext } from "react";

export const EnableAnimationsContext = createContext<boolean>(true);

export function useEnableAnimationsContext(): boolean {
  return useContext(EnableAnimationsContext);
}
